import { FormOrientationContext } from 'components/common-form/contexts/FormOrientationContext';
import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import { Comment } from './Comment';
import { FightingBackJustification } from './FightingBackJustification';
import type { SidePanelProps } from './SidePanel.connect';
import { connectSidePanel } from './SidePanel.connect';
import { Status } from './Status';
import { TradeAllocationButtons } from './TradeAllocationButtons';
import { ValidationErrors } from './validationErrors';

import '../../style.scss';

export const Component: FC<SidePanelProps> = ({
  tabId,
  isin,
  bcsKey,
  productId,
  rfqId,
  fightingBackJustification,
  fightingBackComment,
  isReadyToApply,
  isTradeWithMonetaryScheduleNotStarted,
  isTradeWithMonetaryScheduleClosed,
  isMonetarySchedulePriceUnavailable,
  tradeId,
  applyStatus,
  isReadOnly,
  isLoading,
  canApply,
  productTradingFormOptions,
  onFightingBackJustificationChanged,
  onFightingBackCommentChanged,
  onApply,
  onReload,
  openInSecondaryMarketQuote,
  openInAddOn,
}) => {
  const isMonetaryScheduleOpenedOrNotEnabled =
    !isTradeWithMonetaryScheduleNotStarted && !isTradeWithMonetaryScheduleClosed;

  return (
    <FormOrientationContext.Provider value="vertical">
      <div className="trade-allocation-side-panel card h-100 bg-lvl1 border-start d-flex flex-column position-relative">
        <h5 className="card-title m-4">
          <FormattedMessage id="sidePanel.tabs.tradeAllocation" />
        </h5>
        <Status tabId={tabId} />
        <div id="side-panel-header" data-e2e="side-panel-header">
          <ValidationErrors tabId={tabId} onlyErrorsDisplayedInSummary={false} errorPrefix="" className="mt-3 mx-3" />
        </div>
        {isMonetaryScheduleOpenedOrNotEnabled && (
          <>
            <div className="mx-3 mt-3">
              <FightingBackJustification
                value={fightingBackJustification ?? ''}
                disabled={isReadOnly}
                onChange={onFightingBackJustificationChanged}
                isLoading={isLoading}
              />
            </div>
            <div className="comment-input mx-3 flex-grow-1 overflow-y-auto">
              <Comment
                value={fightingBackComment ?? ''}
                disabled={isReadOnly}
                onChange={onFightingBackCommentChanged}
                isLoading={isLoading}
              />
            </div>
          </>
        )}
        {!isLoading && (
          <TradeAllocationButtons
            onApply={onApply}
            isReadyToApply={isReadyToApply}
            onReload={() => onReload(tradeId)}
            applyStatus={applyStatus}
            isReadOnly={isReadOnly}
            canApply={canApply}
            isTradeWithMonetaryScheduleNotStarted={isTradeWithMonetaryScheduleNotStarted}
            isTradeWithMonetaryScheduleClosed={isTradeWithMonetaryScheduleClosed}
            isMonetarySchedulePriceUnavailable={isMonetarySchedulePriceUnavailable}
            productTradingFormOptions={productTradingFormOptions}
            openInSecondaryMarketQuote={option => openInSecondaryMarketQuote(option, isin, bcsKey)}
            openInAddOn={() => openInAddOn(productId, rfqId, isin)}
          />
        )}
      </div>
    </FormOrientationContext.Provider>
  );
};

export const SidePanel = connectSidePanel(Component);

SidePanel.displayName = 'TradeAllocationSidePanel';
